import React from "react";
import introVelvet from './Images/page/Intro_velvet.png';



class Header extends React.Component {

    render() {
        return (
            <div>
                <div className="header__page">
                    <header>
                        <h1 className="display-4">Welcome to <strong>Score Gym</strong>(build 0.8)</h1>
                    </header>
                </div>
                {/* <div className="velvet_intro"> */}
                        {/* <img src={introVelvet} style={{width: "100vw"}} /> */}
                    {/* </div> */}
                
            </div>
        )
    }
}

export default Header;